import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { usePageReferences } from "../PageReference";

const TocPageNumber = ({ anchorId, isChild = false }) => {
    const pageReferences = usePageReferences();

    return (
        <Text
            style={isChild ? styles.tocChildPage : styles.tocPage}
            render={() => {
                const page = pageReferences?.current?.get(anchorId);

                return page ? `${page}` : "";
            }}
        />
    );
};

const flattenEntries = (entries = [], t) => {
    const rows = [];

    entries.forEach((entry) => {
        rows.push({
            key: `${entry.number || "root"}-${entry.title}`,
            label: entry.number
                ? `${entry.number}. ${t(entry.title)}`
                : t(entry.title),
            anchorId: entry.anchorId,
            isChild: false,
        });

        (entry.children || []).forEach((child) => {
            rows.push({
                key: `${entry.number}-${child.number}-${child.title}`,
                label: `${child.number} ${t(child.title)}`,
                anchorId: child.anchorId,
                isChild: true,
            });
        });
    });

    return rows;
};

const TableOfContents = ({ t, entries = [], subtitle }) => {
    const rows = flattenEntries(entries, t);

    return (
        <View style={styles.tocContent}>
            <Text style={styles.tocHeading}>{t("Table of Contents")}</Text>
            {subtitle ? (
                <Text style={styles.tocSubtitle}>{subtitle}</Text>
            ) : null}

            <View style={styles.tocTable}>
                <View style={styles.tocHeaderRow} wrap={false}>
                    <Text style={styles.tocHeaderSection}>{t("Section")}</Text>
                    <Text style={styles.tocHeaderPage}>{t("Page")}</Text>
                </View>

                {rows.map((row, index) => {
                    const rowStyle = {
                        ...(row.isChild ? styles.tocChildRow : styles.tocRow),
                        ...(index % 2 === 1 ? styles.tocRowAlt : {}),
                    };

                    return (
                        <View
                            style={{
                                ...rowStyle,
                                ...(index === rows.length - 1 ? styles.tocLastRow : {}),
                            }}
                            key={row.key}
                            wrap={false}
                        >
                            <Text style={row.isChild ? styles.tocChildLabel : styles.tocLabel}>
                                {row.label}
                            </Text>
                            <TocPageNumber
                                anchorId={row.anchorId}
                                isChild={row.isChild}
                            />
                        </View>
                    );
                })}
            </View>
        </View>
    );
};

export default withNamespaces()(TableOfContents);
